import { render, staticRenderFns } from "./WorkstationDialog.vue?vue&type=template&id=66c224dc&"
import script from "./WorkstationDialog.vue?vue&type=script&lang=js&"
export * from "./WorkstationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports